import React, {useCallback, useContext, useEffect, useState} from 'react';

import {
    Button,
    Card,
    CardContent,
    CardMedia,
    Chip,
    Dialog, DialogActions,
    DialogContent, DialogContentText,
    DialogTitle,
    Menu,
    MenuItem,
    Box, IconButton, ListItemIcon, Tooltip,
    Paper, Avatar
} from "@mui/material";
import Grid from '@mui/material/Grid';
import ListItemText from "@mui/material/ListItemText";
import {useNavigate} from "react-router-dom";
import {PAContext} from "../../../Services/PAContext";

import lodgingHeaderImage from "../../../graphics/th-513411954.jpg";
import Typography from "@mui/material/Typography";

import TodoCard from "./TodoCard";
import './todo.css';

import Badge from "@mui/material/Badge";

import {selectedChipStyle} from "../../ButtonStyle/Selected";
import {unselectedChipStyle} from "../../ButtonStyle/Unselected";
import {capitalizeFirstLetter, formatName, stringAvatar, stringToColor} from "../../Helpers/TextStyling";
import usePA_GlobalStore from "../../../Services/ZustandGlobalStore";
import InfoTodo from "../../Dialogs/InfoTodo";
import {getAllContactsFromDatabase} from "../../Restricted/Contacts/BrowserDatabaseFunctions";



function TodoList() {

    const navigate = useNavigate();

    const { PA_GlobalObject, set_PA_GlobalObject } = usePA_GlobalStore();

    const { dataArray, sendSocketMessage } = useContext(PAContext);
    const { Account, Attendees, SampleAttendees, authenticated } = dataArray;

    const [dbContacts, setDbContacts] = useState([]);
    // Load Contacts from IndexedDB when authenticated
    useEffect(() => {
        if (!authenticated) {
            setDbContacts([]);
            return;
        }

        let cancelled = false;

        getAllContactsFromDatabase()
            .then(contacts => {
                if (cancelled) return;
                setDbContacts(Array.isArray(contacts) ? contacts : []);
            })
            .catch(err => {
                console.error('Failed to load Contacts from browser DB:', err);
                if (!cancelled) {
                    setDbContacts([]);
                }
            });

        return () => {
            cancelled = true;
        };
    }, [authenticated]);

    const [ attendeesReferenceArray, setAttendeesReferenceArray ] = useState( authenticated
        ? dbContacts
        : SampleAttendees);

    useEffect(() => {

        console.log("authenticated, dbContacts, SampleAttendees triggered ...");

        setAttendeesReferenceArray(
            authenticated
                ? dbContacts
                : SampleAttendees
        );
    }, [authenticated, dbContacts, SampleAttendees]);

    const [eventTodos, setEventTodos] = useState(() => PA_GlobalObject?.Planning?.to_do ?? []);
    const sortedAttendees = PA_GlobalObject?.Planning?.attendees
        .slice()
        .sort((a, b) =>
        (a?.nickname ?? "").localeCompare(b?.nickname ?? "", undefined, { sensitivity: "base" })
    );
    const [selectedAttendee, setSelectedAttendee] = useState(Account?.id ?? null);

    useEffect(() => {
        console.log("PA_GlobalObject?.Planning?.to_do got triggered");
        // update eventTodos but only if changes were made
        const planningTodos = PA_GlobalObject?.Planning?.to_do ?? [];
        let changesFound = false;
        const updated = [];

        // helper: compare meaningful fields shallowly (customize as needed)
        const shallowEqualTodo = (a, b) => {
            console.log("shallowEqualTodo");
            if (a === b) return true;
            if (!a || !b) return false;
            const keys = new Set([...Object.keys(a), ...Object.keys(b)]);
            for (const k of keys) {
                // ignore runtime-only props if any:
                // if (k === '_ui') continue;
                if (a[k] !== b[k]) return false;
            }
            return true;
        };

        // build updated list from Planning as source of truth
        for (const p of planningTodos) {
            console.log("p of planningTodos : ", p);
            const pid = String(p?.id ?? p?.temp_id ?? "");
            const idx = eventTodos.findIndex(itm =>
                String(itm?.id ?? itm?.temp_id ?? "") === pid
            );

            if (idx === -1) {
                // new todo
                console.log("p is NEW");
                changesFound = true;
                updated.push(p);
            } else {
                // existing; only mark change if shallow-different
                const current = eventTodos[idx];
                if (!shallowEqualTodo(current, p)) {
                    changesFound = true;
                }
                updated.push(p); // keep Planning version
            }
        }

        // if counts differ (some removed), it's a change
        if (planningTodos.length !== eventTodos.length) {
            changesFound = true;
        }

        console.log("changesFound : ", changesFound);

        if (changesFound) {
            setEventTodos(updated);
        }
    }, [PA_GlobalObject?.Planning?.to_do]);

    const handleChipClick = useCallback((id) => setSelectedAttendee(id), []);

    const [anchorTodosListMenu, setAnchorTodosListMenu] = useState(null);
    const handleTodosListMenuOpenMenu = (event) => {
        setAnchorTodosListMenu(event.currentTarget);
    };
    const handleTodosListMenuClick = (event) => {
        const target = event.currentTarget;
        const dataId = target.getAttribute('data-id');

        handleTodosListMenuClose();

        if (dataId === "new-entry"){
            navigate('/Planner/Todo/AddNew');
        }
    };
    const handleTodosListMenuClose = () => {
        setAnchorTodosListMenu(null);
    };

    const [todoToDelete, setTodoToDelete] = useState(null);  // Holds the to-do to delete for confirmation dialog
    const [isDeleteDialogOpen, setDeleteDialogOpen] = useState(false);  // Controls the confirmation dialog visibility
    const handleDeleteTodo = (_todo_id, _title) => {
        console.log("handleDeleteTodo : ", _todo_id +":"+_title);
        // Remove the to_do with the given ID
        const updatedTodos = eventTodos.filter(_to_do => _to_do.id !== _todo_id);

        // You can call a function to persist this change or update parent state
        setEventTodos(eventTodos);

        //this updates the to_do array at the Global level
        set_PA_GlobalObject((prev) => ({
            Planning: {
                ...prev.Planning, // Retain all existing fields in Planning
                to_do: updatedTodos,
            },
        }));

        //send over to the server
        if (PA_GlobalObject.Planning.status!== 10){
            const _sendString = {};
            _sendString.action = "E_deleteEventTodo_v2";
            _sendString.event_id = PA_GlobalObject.Planning.id;
            _sendString.todo_id = _todo_id;
            _sendString.title = _title;

            sendSocketMessage(_sendString);

        }

        closeDeleteDialog();

    };
    const openDeleteDialog = (_to_do) => {
        setTodoToDelete(_to_do);  // Set the to_do to be deleted
        setDeleteDialogOpen(true);  // Open the confirmation dialog
    };
    const closeDeleteDialog = () => {
        setTodoToDelete(null);  // Reset the to_do to be deleted
        setDeleteDialogOpen(false);  // Close the confirmation dialog
    };


    const [isTodoInfoDialogOpen, setTodoInfoDialogOpen] = useState(false);


    return (
        <div className="todo-list-container">

            {/* --- TO-DO HEADER --- */}
            <Paper
                elevation={0}
                sx={{
                    p: 1.5,
                    background: 'rgba(255, 255, 255, 0.8)',
                    backdropFilter: 'blur(12px)',
                    border: '1px solid rgba(255, 255, 255, 0.6)',
                    boxShadow: '0 4px 24px -6px rgba(0,0,0,0.06)',
                    borderRadius: '12px 12px 0 0',
                }}
            >
                <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>

                    {/* Title Area */}
                    <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
                        <Box sx={{
                            background: 'linear-gradient(135deg, #f97316 0%, #ef4444 100%)', // Orange to Red gradient
                            p: 0.9,
                            borderRadius: '10px',
                            display: 'flex',
                            boxShadow: '0 4px 10px rgba(249, 115, 22, 0.3)'
                        }}>
                            <i className="icon-checklist" style={{color: 'white', fontSize: '18px'}}/>
                        </Box>
                        <Box sx={{minWidth: 0}}>
                            <Typography variant="h6" sx={{
                                fontWeight: 800,
                                color: '#1e293b',
                                fontSize: '1rem',
                                letterSpacing: -0.4,
                                whiteSpace: 'nowrap'
                            }}>
                                To-Do
                            </Typography>
                            <Box sx={{display: 'flex', alignItems: 'center', gap: 0.3}}>
                                <i className="icon-alarm" style={{color: '#f97316', fontSize: '10px'}}/>
                                <Typography variant="caption" sx={{
                                    color: '#64748b',
                                    fontWeight: 700,
                                    fontSize: '0.65rem',
                                    letterSpacing: 0.1,
                                    whiteSpace: 'nowrap'
                                }}>
                                    Task Management & Progress
                                </Typography>
                            </Box>
                        </Box>
                    </Box>

                    {/* Controls Area */}
                    <Box sx={{display: 'flex', alignItems: 'center', gap: 0.5}}>

                        {/* Info Icon */}
                        <Tooltip title="To-Do Info">
                            <IconButton
                                onClick={() => setTodoInfoDialogOpen(!isTodoInfoDialogOpen)}
                                sx={{color: '#64748b'}}
                            >
                                <i className="icon-info-circle" style={{fontSize: '20px'}}/>
                            </IconButton>
                        </Tooltip>

                        {/* Menu Add Button */}
                        <Tooltip title="Add Task">
                            <IconButton
                                onClick={handleTodosListMenuOpenMenu}
                                sx={{
                                    ml: 0.5,
                                    bgcolor: '#1e293b',
                                    color: 'white',
                                    borderRadius: '12px',
                                    width: '38px',
                                    height: '38px',
                                    boxShadow: '0 4px 12px rgba(30, 41, 59, 0.25)',
                                    transition: 'all 0.2s ease',
                                    '&:hover': {
                                        bgcolor: '#334155',
                                        transform: 'translateY(-1px)',
                                        boxShadow: '0 6px 16px rgba(30, 41, 59, 0.3)',
                                    },
                                    '&:active': {transform: 'translateY(0px)'}
                                }}
                            >
                                <i className="icon-plus" style={{fontSize: '20px'}}/>
                            </IconButton>
                        </Tooltip>

                        {/* Awesome To-Do Menu */}
                        <Menu
                            anchorEl={anchorTodosListMenu}
                            open={Boolean(anchorTodosListMenu)}
                            onClose={handleTodosListMenuClose}
                            PaperProps={{
                                sx: {
                                    width: '280px',
                                    borderRadius: '16px',
                                    mt: 1.5,
                                    boxShadow: '0px 15px 35px rgba(249, 115, 22, 0.15)',
                                    border: '1px solid #f1f3f5',
                                    p: 1
                                }
                            }}
                            transformOrigin={{horizontal: 'right', vertical: 'top'}}
                            anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
                        >
                            <Box sx={{px: 2, py: 1, mb: 1, borderBottom: '1px solid #f1f3f5'}}>
                                <Typography
                                    sx={{fontSize: '11px', fontWeight: 900, color: '#64748b', letterSpacing: 0.5}}>
                                    ACTION ITEMS
                                </Typography>
                            </Box>

                            <MenuItem
                                data-id="new-entry"
                                onClick={handleTodosListMenuClick}
                                sx={{
                                    borderRadius: '12px',
                                    py: 1.5,
                                    '&:hover': {bgcolor: '#fff7ed'}
                                }}
                            >
                                <ListItemIcon sx={{
                                    minWidth: '42px',
                                    height: '42px',
                                    bgcolor: '#ffedd5', // Light orange background
                                    borderRadius: '10px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    mr: 2
                                }}>
                                    <i className="icon-checklist-time" style={{color: '#ea580c', fontSize: '20px'}}/>
                                </ListItemIcon>

                                <ListItemText
                                    primary="Create New Task"
                                    secondary="Add a specific to-do item"
                                    primaryTypographyProps={{
                                        fontWeight: 800,
                                        fontSize: '14px',
                                        color: '#1e293b'
                                    }}
                                    secondaryTypographyProps={{
                                        fontSize: '11px',
                                        fontWeight: 600,
                                        color: '#64748b'
                                    }}
                                />
                            </MenuItem>
                        </Menu>
                    </Box>
                </Box>
            </Paper>


            {/* show the list of attendees */}
            <div className="todo-list-attendee-list-container" style={{
                display: 'flex',
                overflowX: 'auto',
                msOverflowStyle: 'none',
                alignItems: 'flex-start'
            }}>
                {sortedAttendees.map((attendee) => {
                    // 1. Logic to find the real avatar data
                    const attendeeAvatar = attendeesReferenceArray.find((_att) => _att.id === attendee.id);
                    const isSelected = selectedAttendee === attendee.id;

                    const fullName = attendee.nickname?.trim()
                        ? `${formatName(attendee.nickname)}`
                        : `${formatName(attendee.fname)} ${formatName(attendee.lname)}`;

                    return (
                        <Box
                            key={attendee.id}
                            onClick={() => handleChipClick(attendee.id)}
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                cursor: 'pointer',
                                position: 'relative',
                                minWidth: '60px',
                                transition: 'transform 0.2s ease',
                                '&:hover': {transform: 'translateY(-2px)'}
                            }}
                        >
                            {/* 2. The Notification Badge for Document Counts */}
                            <Badge
                                badgeContent={
                                    (() => {
                                        const viewerId = String(Account?.id ?? "");
                                        const count = (eventTodos ?? []).reduce((sum, td) => {
                                            const assigned = String(td?.assigned_to) === String(attendee.id);
                                            const visible = !(td?.is_private ?? td?.private) || String(td?.assigned_to) === viewerId;
                                            return sum + (assigned && visible ? 1 : 0);
                                        }, 0);
                                        return count > 0 ? count : null;
                                    })()
                                }
                                sx={{
                                    '& .MuiBadge-badge': {
                                        backgroundColor: '#E0F2F1', // Soft Mint/Teal
                                        color: '#00695C',           // Dark Teal text
                                        fontSize: '10px',
                                        fontWeight: 900,
                                        border: '2px solid #fff',
                                        top: 5,
                                        right: 5
                                    },
                                }}
                            >
                                {/* 3. The Avatar with your Lodging Logic */}
                                <Box sx={{
                                    p: '3px',
                                    borderRadius: '50%',
                                    border: isSelected ? '2px solid #151269' : '2px solid transparent',
                                    transition: 'all 0.3s ease'
                                }}>
                                    {
                                        !attendeeAvatar?.avatar || !attendeeAvatar?.avatar.preview ? (
                                            <Avatar
                                                {...stringAvatar(fullName)}
                                                sx={{
                                                    width: 30,
                                                    height: 30,
                                                    fontSize: '16px',
                                                    fontWeight: 600,
                                                    boxShadow: isSelected ? '0 4px 10px rgba(21, 18, 105, 0.2)' : 'none',
                                                    border: `1px solid ${stringToColor(fullName)}`
                                                }}
                                            />
                                        ) : (
                                            <Avatar
                                                src={attendeeAvatar.avatar.preview}
                                                sx={{
                                                    width: 30,
                                                    height: 30,
                                                    boxShadow: isSelected ? '0 4px 10px rgba(21, 18, 105, 0.2)' : 'none',
                                                    border: `1px solid ${stringToColor(fullName)}`
                                                }}
                                            />
                                        )
                                    }
                                </Box>
                            </Badge>

                            {/* 4. Name Label */}
                            <Typography sx={{
                                fontSize: '11px',
                                fontWeight: isSelected ? 800 : 500,
                                mt: 1,
                                color: isSelected ? '#151269' : '#666',
                                textAlign: 'center',
                                maxWidth: '70px',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap'
                            }}>
                                {capitalizeFirstLetter(attendee.nickname || attendee.fname)}
                            </Typography>
                        </Box>
                    );
                })}
            </div>


            {/* show the list of Todos */}
            <div className="todo-list-items-container">

                {
                    eventTodos && eventTodos.length > 0 ? (
                        eventTodos
                            .filter(_item => _item.assigned_to === selectedAttendee)
                            .map((todoItem) => (

                                <Grid
                                    item
                                    key={`${todoItem.id || todoItem.temp_id}`} // Ensure key is unique to the current to_do and date/day selection
                                    sx={{display: 'flex'}}>

                                    <TodoCard
                                        to_do={todoItem}
                                        onDeleteTodo={() => openDeleteDialog(todoItem)}
                                    />

                                </Grid>

                            ))
                    ) : (
                        <Grid item>
                            <Paper elevation={2} sx={{margin: '20px'}}>
                                <Card>
                                    <CardMedia
                                        sx={{height: 140}}
                                        image={lodgingHeaderImage}
                                        title="Add Todo Items"
                                    />
                                    <CardContent>
                                        <Typography gutterBottom variant="h7" component="div">
                                            Add any type of Todo Item
                                        </Typography>
                                        <Typography gutterBottom variant="body2" color="text.secondary">
                                            There are several ways to easily add Lodgings:
                                        </Typography>
                                        <Typography gutterBottom variant="body2" color="text.secondary">
                                            1. <strong>From the Map</strong>. Use the <strong>Search Bar</strong>.
                                            Select the BUSINESS icon and search the area for <strong>Hotels, Motels,
                                            Campgrounds</strong>.
                                        </Typography>
                                        <Typography gutterBottom variant="body2" color="text.secondary">
                                            2. <strong>From the Map</strong>. Use the <strong>Search Bar</strong>.
                                            Select the HOUSE icon and search the area for <strong>VRBO, AirBnB, Personal
                                            Residence</strong>.
                                        </Typography>
                                        <Typography gutterBottom variant="body2" color="text.secondary">
                                            3. <strong>From a PDF Receipt</strong>.
                                            We'll have our AI Concierge extract the relevant details from the PDF and
                                            let you see what we've
                                            found. You can edit the results before we actually add the details to the
                                            Itinerary.
                                        </Typography>
                                        <Typography gutterBottom variant="body2" color="text.secondary">
                                            4. <strong>Camping</strong>. Use your GPS to pinpoint your location. Click
                                            on the
                                            <i className="icon-menu2"/> above.
                                        </Typography>
                                        <Typography gutterBottom variant="body2" color="text.secondary">
                                            5. <strong>Enter manually</strong>. Fill in the input boxes with the exact
                                            Lodging details.
                                        </Typography>

                                    </CardContent>
                                </Card>

                            </Paper>
                        </Grid>
                    )

                }
            </div>

            {/* Confirmation Dialog */}
            <Dialog
                open={isDeleteDialogOpen}
                onClose={closeDeleteDialog}
            >
                <DialogTitle>Delete To-Do Item</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to delete the item "{todoToDelete?.title}"? This action cannot be undone.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeDeleteDialog} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={() => handleDeleteTodo(todoToDelete.id, todoToDelete.title)} color="secondary">
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>


            <InfoTodo
                isOpen={isTodoInfoDialogOpen}
                onClose={() => setTodoInfoDialogOpen(false)}
            />

        </div>
    )

}

export default TodoList;
